import Vue from 'vue'
import VueI18n from 'vue-i18n'

var lang = typeof window.wplang !== "undefined" && window.wplang == 'fr_CA' ? 'fr' : 'en';

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'en',
  messages:{
    en: {
      'All Wheel Drive' : 'All Wheel Drive',
      'Back-Up Camera' : 'Back-Up Camera',
      'bi-weekly': 'bi-weekly',
      'Bluetooth Connection': 'Bluetooth Connection',
      'Cloth Seats': 'Cloth Seats',
      'Electric Motor': 'Electric Motor',
      'Heated Front Seats': 'Heated Front Seats',
      new: 'new',      
      New: 'New',
      NEW: 'NEW',
      'high to low': 'high to low',
      'low to high': 'low to high',
      mileage: 'mileage',
      monthly: 'monthly',
      Moonroof: 'Moonroof',
      'Leather Seats': 'Leather Seats',
      'Long Bed': 'Long Bed',
      'newest to oldest': 'newest to oldest',
      price: 'price',
      'oldest to newest': 'oldest to newest',
      'Please select a model': 'Please select a model',
      'Remote Engine Start': 'Remote Engine Start',
      used: 'used',
      Used: 'Used',
      USED: 'USED',
      year: 'year',
      'Navigation System': 'Navigation System',
      'Power Driver Seats': 'Power Driver Seats',
      'Satellite Radio': 'Satellite Radio',
      'Short Bed': 'Short Bed',
      'Show less': 'Show less',      
      weekly: 'weekly',
      'Keyless Entry': 'Keyless Entry',
      'Keyless Start': 'Keyless Start',
      'Vehicle video': 'Vehicle video',
      'View more': 'View more',
    },
    fr: {
      'All Wheel Drive' : 'Traction Intégrale',
      'Back-Up Camera' : 'Caméra de Recul',
      'bi-weekly': 'aux deux semaines',
      'Bluetooth Connection': 'Connexion Bluetooth',
      'Cloth Seats': 'Sièges en Tissu',
      'Electric Motor': 'Moteur Électrique',
      'Heated Front Seats': 'Sièges Avant Chauffants',
      new: 'neuf',
      New: 'Neuf',
      NEW: 'NEUF',
      'high to low': 'élevé à faible',
      'low to high': 'faible à élevé',
      mileage: 'kilométrage',
      monthly: 'mensuel',
      Moonroof: 'Toit Ouvrant',
      'Leather Seats': 'Sièges en Cuir',
      'Long Bed': 'Lit Long',
      'newest to oldest': 'Plus récent à plus ancien',
      price: 'prix',
      'Please select a model': 'Veuillez sélectionner un modèle',
      'Remote Engine Start': 'Démarrage à Distance du Moteur',
      'oldest to newest': 'Plus ancienne à plus récente',
      used: 'occasion',
      Used: 'Occasion',
      USED: 'OCCASION',
      year: 'Année',
      'Navigation System': 'Système de Navigation',      
      'Power Driver Seats': 'Sièges Conducteur Électriques',
      'Satellite Radio': 'Radio Satellite',
      'Short Bed': 'Lit Court',
      'Show less': 'Montrer Moins',      
      weekly: 'semaine',
      'Keyless Entry': 'Entrée sans Clé',
      'Keyless Start': 'Démarrage sans Clé',
      'Vehicle video': 'Vidéo du véhicule',
      'View more': 'Voir plus',
      '3rd Row Seat': '3e rangée de sièges',
      'Adaptive Cruise Control': 'Régulateur de vitesse adaptatif',
      'Radio Satellite': 'Radio satellite',
      'WiFi Hotspot': 'Point d\'accès sans fil',
      'Heated Rear Seat(s)': 'Sièges arrière chauffants',
      'DIESEL': 'DIESEL',
      'ELECTRIC': 'ÉLECTRIQUE',
      'GAS': 'ESSENCE',
      'HYBRID': 'HYBRIDE',
      'OTHER': 'AUTRE',
      'PHEV': 'PHEV',
      'Convertible': 'Cabriolet',
      'DEMO': 'DÉMO',
      'demo': 'démo',
      'IN STOCK': 'EN STOCK',
      'in stock': 'en stock',
      'in-stock': 'en-stock',
      'INCOMING': 'À VENIR',
      'incoming': 'à venir',
      'SPECIAL': 'SPÉCIAL',
      'special': 'spécial',
      'Vans': 'Fourgonnettes',
      'All': 'Tous',
      'Trucks': 'Camions',
      'SUV': 'VUS',
      'SUV & Crossover': 'VUM et VUS',
      'Commercial': 'Commerciaux',
      'Electric': 'Électriques',
      'Electrified': 'Électrifiés',
      'Hybrid': 'Hybrides',
      'Cars': 'Voitures',
      'Minivans': 'Minifourgonnettes',
    }
  }
})